import { createEffect } from 'effector'
import { getServicePageFx } from '../Api/PaidService/servicePage'
import api from '../Auth/api'
import { successModal, updateModal } from '../components/ErrorModal'

export const sendParameters = (paidServiceId, id, meta, files) => {
  let parameters = {
    meta: { ...meta },
    id: id,
    fileIds: (files || []).map((file) => file.id)
  }
  updateTask({ paidServiceId, parameters })
}
export const sendParametersForEdit = (paidServiceId, id, meta, files) => {
  let parameters = {
    meta: { ...meta },
    id: id,
    fileIds: (files || []).map((file) => file.id)
  }
  console.log('parameters - ', parameters)
  editTask({ paidServiceId, parameters })
}

export const updateTask = createEffect(
  async ({ paidServiceId, parameters }) => {
    api
      .post(`paid-service/task-update`, parameters)
      .then((res) => {
        res?.data?.data?.finishResult?.success
          ? successModal('Сохранение прошло успешно')
          : updateModal(res?.data?.data?.finishResult?.errors)
      })
      .then(
        () => getServicePageFx(paidServiceId),
        (error) => updateModal(error.response.data.errors)
      )
  }
)
export const editTask = createEffect(async ({ paidServiceId, parameters }) => {
  api
    .put(`paid-service/task`, parameters)
    .then((res) => {
      res?.data?.data?.finishResult?.success
        ? successModal('Сохранение прошло успешно')
        : updateModal(res?.data?.data?.finishResult?.errors)
    })
    .then(
      () => getServicePageFx(paidServiceId),
      (error) => updateModal(error.response.data.errors)
    )
})
export const rollbackTask = createEffect(
  async ({ paidServiceId, id, message }) => {
    api.post(`paid-service/task-rollback`, { id, message }).then(
      () => getServicePageFx(paidServiceId),
      (error) => updateModal(error.response.data.errors)
    )
  }
)
